export default __webpack_public_path__ + "static/media/shift-records-icon.6f7e0f36.svg";